import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import _ from 'lodash'
import { withUserStore } from '../../contexts/UserStore'
import { withTracker } from 'ga-4-react'

const Tracker = withTracker(props => <>{JSON.stringify(props)}</>)

const PageWrapper = ({ userStore, name, meta, children }) => {
  const location = useLocation()

  const useTracker = () => {
    return userStore.env === 'production' && location
  }

  const hash = location?.hash?.replace(/^#/, '') || ''

  let title = 'Prioritize.Plus'
  if (name) title = `${title} | ${name}`
  if (hash) title = `${title} | ${_.capitalize(hash)}`

  return (<>
    {useTracker() &&
      <div className="hidden"><Tracker path={location.href} title={title} gaCode="G-JV8J9X2CD8" /></div>}
    {<Helmet>
      <title> {title} </title>
      {meta && <meta name="description" content={meta} />}
    </Helmet>}
    {children}
  </>)
}

PageWrapper.propTypes = {
  userStore: PropTypes.object.isRequired,
  name: PropTypes.string,
  meta: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default withUserStore(PageWrapper)
